export * from './qr-reader';
